// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-background {
  background: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.w-h-100 {
  width: 100%;
  height: 100vh;
}

.bg-container {
  height: 100vh;
  background-color: var(--color-primary-blue);
  z-index: -1;
}
.bg-container .bg-lantern {
  background: url('lantern-bg-center.abc340e703648ea0.svg') no-repeat center center;
  background-size: auto 100%;
}
.bg-container .bg-rice-paper {
  background: url('2048_rice-paper-6.802831c259f141f5.png');
  opacity: 0.7;
  mix-blend-mode: multiply;
}
.bg-container .bg-dark-blue {
  background: url('bg_blue_blur_dark.72ca532f81638e8a.png');
  opacity: 0.7;
  mix-blend-mode: normal;
}

.start-btn {
  min-width: 10.667rem;
  height: 2.667rem;
  min-height: 2.667rem;
  --min-height: 2.667rem;
  font-size: 1.167rem;
  font-weight: 600;
}

.logo-small {
  position: absolute;
  top: 2.083rem;
  right: 2.25rem;
  height: 4.075rem;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 13rem;
  margin-top: 4rem;
}
.container .texts {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  z-index: 5;
}
.container .texts .text1 {
  font-size: 1.167rem;
  color: var(--color-primary-blue);
  font-weight: bold;
}
.container .texts .text2 {
  font-size: 5.1rem;
  margin-top: -1.5rem;
  color: var(--color-white);
  font-weight: 600;
}
.container .texts .text3 {
  font-size: 1rem;
  color: var(--color-primary-blue);
  font-weight: 400;
}
.container .avatar {
  width: 4.8rem;
  margin-top: 4rem;
}
.container .logo {
  width: 11.75rem;
  height: 12.333rem;
  margin-left: -7rem;
  margin-top: -5rem;
}

.store-box {
  position: absolute;
  top: 2.083rem;
  left: 2.25rem;
}
.store-box .logo-ios,
.store-box .logo-android {
  height: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/launch-screen/launch-screen.page.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,2CAAA;EACA,WAAA;AACF;AACE;EACE,iFAAA;EACA,0BAAA;AACJ;AAEE;EACE,yDAAA;EACA,YAAA;EACA,wBAAA;AAAJ;AAGE;EACE,yDAAA;EACA,YAAA;EACA,sBAAA;AADJ;;AAKA;EACE,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAFF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAFJ;AAII;EACE,mBAAA;EACA,gCAAA;EACA,iBAAA;AAFN;AAKI;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAHN;AAMI;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAJN;AAQE;EACE,aAAA;EACA,gBAAA;AANJ;AASE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;AARF;AAUE;;EAEE,YAAA;AARJ","sourcesContent":[".main-background {\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.w-h-100 {\n  width: 100%;\n  height: 100vh;\n}\n\n.bg-container {\n  height: 100vh;\n  background-color: var(--color-primary-blue);\n  z-index: -1;\n\n  .bg-lantern {\n    background: url(../../../assets/d1/lantern-bg-center.svg) no-repeat center center;\n    background-size: auto 100%;\n  }\n\n  .bg-rice-paper {\n    background: url(../../../assets/d1/2048_rice-paper-6.png);\n    opacity: 0.7;\n    mix-blend-mode: multiply;\n  }\n\n  .bg-dark-blue {\n    background: url(../../../assets/d1/bg_blue_blur_dark.png);\n    opacity: 0.7;\n    mix-blend-mode: normal;\n  }\n}\n\n.start-btn {\n  min-width: 10.667rem;\n  height: 2.667rem;\n  min-height: 2.667rem;\n  --min-height: 2.667rem;\n  font-size: 1.167rem;\n  font-weight: 600;\n}\n\n.logo-small {\n  position: absolute;\n  top: 2.083rem;\n  right: 2.25rem;\n  height: 4.075rem;\n}\n\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 13rem;\n  margin-top: 4rem;\n\n  .texts {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    z-index: 5;\n\n    .text1 {\n      font-size: 1.167rem;\n      color: var(--color-primary-blue);\n      font-weight: bold;\n    }\n\n    .text2 {\n      font-size: 5.1rem;\n      margin-top: -1.5rem;\n      color: var(--color-white);\n      font-weight: 600;\n    }\n\n    .text3 {\n      font-size: 1rem;\n      color: var(--color-primary-blue);\n      font-weight: 400;\n    }\n  }\n\n  .avatar {\n    width: 4.8rem;\n    margin-top: 4rem;\n  }\n\n  .logo {\n    width: 11.75rem;\n    height: 12.333rem;\n    margin-left: -7rem;\n    margin-top: -5rem;\n  }\n}\n\n.store-box {\n  position:absolute;\n  top: 2.083rem;\n  left: 2.25rem;\n\n  .logo-ios,\n  .logo-android {\n    height: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
